import React, { useEffect, useState } from "react";

import InputLabel from "@mui/material/InputLabel";
import Select from "react-select";

import { doService } from "../../../services/ServiceHelper";
import { getSchoolTags } from "../../../services/ActivityService";

function TagSelector({ label = "Select Tag(s) (optional)", school, jwt, onChange }) {
  const [_tags, setTags] = useState([]);

  useEffect(() => {
    initTags();
  }, []);

  const initTags = () => {
    doService(getSchoolTags(school, jwt), (results) => {
      const entries = [];
      for (const entry of results.data) {
        entries.push({
          label: entry.name,
          value: entry.eid,
        });
      }
      setTags(entries);
    });
  };


  const handleChangeScoreCategories = (value) => {
   if (onChange) {
      onChange(value);
    }
  };

  return (
    <>
      <InputLabel>{label}</InputLabel>
      <Select
        options={_tags}
        onChange={handleChangeScoreCategories}
        isMulti={true}
      />
    </>
  );
}

export default TagSelector;
